module.exports = __webpack_public_path__ + "static/media/Suspension_kits_White.91a3a71a.webp";